<div class="card-search">
  <div class="search-input-wrapper">
    <span zagIcon="search" class="search-icon"></span>
    <input
      type="text"
      class="search-input"
      [placeholder]="placeholder() | translate"
      [value]="immediateSearchValue()"
      (input)="onInputChange($any($event.target).value)"
    />
    @if (immediateSearchValue()) {
      <button type="button" class="clear-button" (click)="clearSearch()" aria-label="Clear search">
        <span zagIcon="close"></span>
      </button>
    }
  </div>
</div>
